import React from "react";
import _ from "lodash";
import Constant from "./Constant";
import moment from "moment";

const dateTextInput = event => {
  let sep = "/";
  let re = new RegExp(sep, "g");
  let sepCount = event.target.value.match(re)
    ? event.target.value.match(re).length
    : 0;

  if (sepCount === 0) {
    if (
      (event.target.value.length === 1 && /^[4-9]$/.test(event.target.value)) ||
      event.target.value.length === 2
    ) {
      event.target.value =
        (event.target.value > 0 &&
        event.target.value < 10 &&
        !event.target.value.includes(0)
          ? 0 + event.target.value
          : event.target.value) + sep;
    }
  } else if (sepCount === 1 && event.target.value.length === 2) {
    event.target.value =
      (event.target.value[0] > 0 && event.target.value[0] < 10
        ? 0 + event.target.value[0]
        : event.target.value[0]) + sep;
  } else if (sepCount === 1) {
    const idx = event.target.value.lastIndexOf(sep);
    let endValue = event.target.value.substring(idx + 1); //get month
    if (
      (endValue.length === 1 && /^[2-9]$/.test(endValue)) ||
      endValue.length === 2
    ) {
      if (endValue.length === 1) {
        //If user key in between 2-9
        if (endValue > 0 && endValue < 10) endValue = "0" + endValue;
        event.target.value = event.target.value.slice(0, 3) + endValue + sep;
      } else {
        event.target.value = event.target.value + sep;
      }
    }
  } else if (
    sepCount === 2 &&
    event.target.value.includes("/", 4) &&
    event.target.value.length === 5
  ) {
    //If user key 1st month and key in "/"
    let endValue = event.target.value[3];
    if (endValue > 0 && endValue < 10) endValue = "0" + endValue;
    event.target.value = event.target.value.slice(0, 3) + endValue + sep;
  }
  return event.target.value;
};

const addCommaInNumber = value => {
  let number = parseFloat(value).toFixed(2);
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const isMultipleOfValue = (value, multiplyValue = 500) => {
  return value % multiplyValue === 0;
};

//Ad Hoc Top Up (SP + Total Ad Hoc Top Up + Requested Ad Hoc Top Up Amount – Total Withdrawal) ≥ $100K
//Set Up Recurring Top Up (SP + Total Ad Hoc Top Up + Requested Recurring Top Up Amount – Total Withdrawal) ≥ $100k
const calculateExceed100K = (
  singlePremium,
  totalTopUp,
  topUpAmount,
  totalWithdrawal
) => {
  let amount;
  amount = singlePremium + totalTopUp + topUpAmount - totalWithdrawal;
  return amount >= 100000;
};

const convertByte = fileSize => {
  if (fileSize === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(fileSize) / Math.log(k));

  return parseFloat((fileSize / Math.pow(k, i)).toFixed(2)) + sizes[i];
};

const thousandSeparator = value => {
  let input = value.toString();
  let parts = input.split(".");
  let part1 = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  let part2 = parts[1];
  if (_.isInteger(value)) {
    return part1;
  } else {
    return part1 + "." + part2;
  }
};

const checkValidNRIC = nric => {
  const firstChar = nric.substring(0, 1);
  if (
    firstChar !== "S" &&
    firstChar !== "T" &&
    firstChar !== "G" &&
    firstChar !== "F"
  ) {
    return false;
  }

  if (nric.length !== 9) {
    return false;
  }
  return true;
};

const isFullSurrender = coverStartDate => {
  const todayDate = moment().format("YYYY-MM-DD");
  const formattedCoverStartDate = moment(coverStartDate, "DD MMM YYYY")
    .add(15, "days")
    .format("YYYY-MM-DD");
  let isSurrender = moment(todayDate).isAfter(formattedCoverStartDate);
  return isSurrender;
};

export default {
  dateTextInput,
  addCommaInNumber,
  isMultipleOfValue,
  calculateExceed100K,
  convertByte,
  thousandSeparator,
  checkValidNRIC,
  isFullSurrender
};
